import { getModule } from "vuex-module-decorators";
import store from "@/store";
import Http from "@/store/http";
import CurrentUser from "@/store/currentUser";
import Auth from "./auth";
import CurrentScouting from "@/store/currentScouting";
import Cable from "@/store/cable";
import CurrentCompany from "@/store/currentCompany";

export const httpStore: Http = getModule(Http, store);
export const currentUserStore: CurrentUser = getModule(CurrentUser, store);
export const authStore: Auth = getModule(Auth, store);
export const currentScoutingStore: CurrentScouting = getModule(
  CurrentScouting,
  store,
);
export const currentCompanyStore: CurrentCompany = getModule(
  CurrentCompany,
  store,
);
export const cableStore: Cable = getModule(Cable, store);
